import React, { Component } from 'react'
import './Mag.css';

import img1 from '../assets/issue_15/001.jpg'
import img2 from '../assets/issue_15/002.jpg'
import img3 from '../assets/issue_15/003.jpg'
import img4 from '../assets/issue_15/004.jpg'
import img5 from '../assets/issue_15/005.jpg'
import img6 from '../assets/issue_15/006.jpg'
import img7 from '../assets/issue_15/007.jpg'
import img8 from '../assets/issue_15/008.jpg'
import img9 from '../assets/issue_15/009.jpg'
import img10 from '../assets/issue_15/010.jpg'
import img11 from '../assets/issue_15/011.jpg'
import img12 from '../assets/issue_15/012.jpg'
import img13 from '../assets/issue_15/013.jpg'
import img14 from '../assets/issue_15/014.jpg'
import img15 from '../assets/issue_15/015.jpg'
import img16 from '../assets/issue_15/016.jpg'
import img17 from '../assets/issue_15/017.jpg'
import img18 from '../assets/issue_15/018.jpg'
import img19 from '../assets/issue_15/019.jpg'
import img20 from '../assets/issue_15/020.jpg'
import img21 from '../assets/issue_15/021.jpg'
import img22 from '../assets/issue_15/022.jpg'
import img23 from '../assets/issue_15/023.jpg'
import img24 from '../assets/issue_15/024.jpg'
import img25 from '../assets/issue_15/025.jpg'
import img26 from '../assets/issue_15/026.jpg'
import img27 from '../assets/issue_15/027.jpg'

export default class Mag015 extends Component {
  render() {
    return (
      <div className="image-container">
        <img src={img1} className="image"></img>
        <img src={img2} className="image"></img>
        <img src={img3} className="image"></img>
        <img src={img4} className="image"></img>
        <img src={img5} className="image"></img>
        <img src={img6} className="image"></img>
        <img src={img7} className="image"></img>
        <img src={img8} className="image"></img>
        <img src={img9} className="image"></img>
        <img src={img10} className="image"></img>
        <img src={img11} className="image"></img>
        <img src={img12} className="image"></img>
        <img src={img13} className="image"></img>
        <img src={img14} className="image"></img>
        <img src={img15} className="image"></img>
        <img src={img16} className="image"></img>
        <img src={img17} className="image"></img>
        <img src={img18} className="image"></img>
        <img src={img19} className="image"></img>
        <img src={img20} className="image"></img>
        <img src={img21} className="image"></img>
        <img src={img22} className="image"></img>
        <img src={img23} className="image"></img>
        <img src={img24} className="image"></img>
        <img src={img25} className="image"></img>
        <img src={img26} className="image"></img>
        <img src={img27} className="image"></img>
      </div>
    )
  }
}
